import classes from "./styles/mainLayout.module.css";
import Footer from "../components/layout/Footer";
import { Outlet } from "react-router-dom";
import Navbar from "../components/layout/Navbar";


const MainLayout = () => {
  return (
    <>
      <header><Navbar/></header>
      <div className={classes.main}><Outlet /></div>
      <footer><Footer/></footer>
    </>
  );
};

export default MainLayout;
